import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const createWaterSportsOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.diving', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.parasailing', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.wakeboarding', value: '3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.surfing', value: '4' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.windsurfing', value: '5' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.watersport.kitesurfing', value: '6' }),
];

type CreateWaterSportsFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createWaterSportsFilters = ({
  searchParams,
  translationDictionary,
}: CreateWaterSportsFilters): Filter[] => {
  const showWaterSportsFilter = isBeachHoliday(searchParams);
  const selectedValues = searchParams[URLParameters.WATERSPORT]?.split(',') || [];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const waterSportsFilter: Filter | undefined = showWaterSportsFilter
    ? {
        name: FILTER_NAME.WATER_SPORTS,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createWaterSportsOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[waterSportsFilter]].filter((f) => !!f);
};
